import React from 'react';
import { IconButton } from '../../../icons';
import { IconType } from '../../../icons/Icon';
import { PdfTableType } from '../PdfComponent';
import { PdfEditorPreviewPage, usePdfTemplateContext } from '../PdfTemplateEditorContext';
import { DropdownSelect } from '../../../components/Dropdown';

export default function PdfTemplateEditorToolbar<T>() {
  const {
    components,
    setComponents,
    defaultComponents,
    setSelectedId,
    dataKeys,
    tableProviders,
    editorSettings,
    updateEditorSettings,
    documentProperties,
    settings,
  } = usePdfTemplateContext<T>();

  const addStaticText = () => {
    const newComponent = defaultComponents.staticText();
    setComponents([newComponent, ...components]);
    setSelectedId(newComponent.id);
  };

  const addField = () => {
    const newComponent = defaultComponents.field();

    setComponents([newComponent, ...components]);
    setSelectedId(newComponent.id);
  };

  const addTableRegion = (tableType: PdfTableType) => {
    const newComponent = defaultComponents.table ? defaultComponents.table(tableType) : undefined;
    if (!newComponent) return;
    setComponents([newComponent, ...components]);
    setSelectedId(newComponent.id);
  };

  const addImage = () => {
    const newComponent = defaultComponents.image();

    setComponents([newComponent, ...components]);
    setSelectedId(newComponent.id);
  };

  const addBarcode = () => {
    const newComponent = defaultComponents.barcode();

    setComponents([newComponent, ...components]);
    setSelectedId(newComponent.id);
  };

  return (
    <div className='pointer-events-auto sticky bottom-4 left-0 right-0 z-40 flex w-full justify-center'>
      <div className='flex items-center gap-2 rounded-3 bg-white p-2 shadow-default'>
        <IconButton type={IconType.type01} text={'Static Text'} onClick={addStaticText} />
        {!!dataKeys.length && <IconButton type={IconType.textInput} text={'Field'} onClick={addField} />}
        {!!tableProviders.length && (
          <IconButton
            type={IconType.columns03}
            text={'Table'}
            onClick={() => addTableRegion(tableProviders[0].tableType)}
          />
        )}
        <IconButton type={IconType.imagePlus} text={'Image'} onClick={addImage} />
        <IconButton type={IconType.activity} text={'Barcode'} onClick={addBarcode} />
        {!!settings.repeatModes.length && (
          <>
            <div className='mx-1 h-6 w-px bg-gray-200' />
            <div className='flex gap-2'>
              <DropdownSelect
                label={'Preview page'}
                items={Object.values(PdfEditorPreviewPage)}
                value={editorSettings.previewPage}
                onSelect={previewPage => updateEditorSettings({ previewPage })}
                textBuilder={v => v}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
